import { TestFieldsView } from './test-view'
import { AquiferViewFormInterface } from './aquifer-test-details-view'
import { TOOLTIP } from '../../../../constants/tooltips'
import { FormField, Heading, ReadOnlyField } from '@msaf/core-react'

export default function AquiferTestResultsViewForm({ fields, isLoading }: AquiferViewFormInterface) {
  return (
    <>
      <Heading isSkeleton={isLoading} level={3}>
        Test results
      </Heading>

      <TestFieldsView fields={fields} isLoading={isLoading} index={0} />
      <FormField isSkeleton={isLoading} label='Assumed aquifer thickness (m)' labelId={`assumedAquiferThickness`}>
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy={`assumedAquiferThickness`}
          value={`${fields.assumedAquiferThickness ?? ''}`}
        />
      </FormField>
      <FormField
        toolTipMessage={TOOLTIP.conductivity}
        isSkeleton={isLoading}
        label='Hydraulic conductivity (m/d)'
        htmlFor='conductivityLabel'
      >
        <ReadOnlyField isSkeleton={isLoading} labelledBy='conductivityLabel' value={`${fields.conductivity ?? ''}`} />
      </FormField>
    </>
  )
}
